"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var existingEnquiryTemplate = "\n<div class=\"ui-notification\">\n  <h3>{{header}}</h3>\n  <div class=\"message\">\n    {{msgBody}}\n    \n    <br />\n    <a class=\"btn btn-success\" ng-click=\"enquiryAcceptedByUser(enquiryId, senderId)\">Accept</a>\n    <a class=\"btn btn-warning\" ng-click=\"enquiryHeldByUser(enquiryId, senderId)\">Hold</a>\n    <a class=\"btn btn-danger\" ng-click=\"enquiryRejectedByUser(enquiryId, senderId)\">Reject</a>\n  </div>\n</div>\n";

exports.default = existingEnquiryTemplate;


// WEBPACK FOOTER //
// ./client/app/common/templates/notification/existingEnquiryTemplate.js